import {useNavigate} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import {useAppDispatch} from 'store/hooks';
import {logoutUser} from 'store/userSlice';

const NotAuthorize = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const handleLogout = () => {
		dispatch(logoutUser());
		navigate('/');
	};

	return (
		<div id="content">
			<div className="total-center container-fluid">
				<div className="text-center">
					<div className="error mx-auto" data-text="401">
						<h1 className="display-1 fw-bold">Opps!</h1>
					</div>
					<p className="lead text-gray-800 mb-5">User Not Authorize</p>
					<p className="text-gray-500 mb-0 lead">
						The session has expired or the session has timed out, please log in
						again...
					</p>
					<Button className="btn btn-primary" onClick={handleLogout}>
						Go Login
					</Button>
				</div>
			</div>
		</div>
	);
};

export default NotAuthorize;
